import { Modal, Form, Input, Button, message } from "antd";
import { useEffect } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import drEasyApi from "../../Api/Customapi";
import { useGetUserData } from "../../hooks/useGetUserData";
import getErrorMessage from "../../hooks/getErrorMssg";

const EditProfileModal = ({ open, onClose }) => {
    const [form] = Form.useForm();
    const queryClient = useQueryClient();

    const { data: userData } = useGetUserData();

    useEffect(() => {
        if (userData) {
            form.setFieldsValue({
                firstName: userData.firstName,
                lastName: userData.lastName,
                phoneNumber: userData.phoneNumber,
            });
        }
    }, [userData, form]);

    const { mutate, isPending } = useMutation({
        mutationFn: async (values) => {
            const payload = {
                firstName: values.firstName,
                lastName: values.lastName,
                phoneNumber: values.phoneNumber,
            };
            await drEasyApi.post("/api/{slug}/User/EditProfile", payload);
        },
        onSuccess: () => {
            message.success("Profile updated successfully");
            queryClient.invalidateQueries(["userData"]);
            onClose();
        },
        onError: (error) => {
            message.error(getErrorMessage(error));
        },
    });

    return (
        <Modal
            title="Edit Profile"
            centered
            open={open}
            onCancel={onClose}
            footer={null}
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={(values) => mutate(values)}
            >
                <div className="flex gap-2 w-full">
                    <Form.Item
                        name="firstName"
                        label="First Name"
                        className="flex-1"
                        rules={[{ required: true, message: "Please enter your first name" }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="lastName"
                        label="Last Name"
                        className="flex-1"
                        rules={[{ required: true, message: "Please enter your last name" }]}
                    >
                        <Input />
                    </Form.Item>
                </div>

                <Form.Item
                    name="phoneNumber"
                    label="Phone Number"
                    rules={[{ required: true, message: "Please enter your phone number" }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item className="mb-0">
                    <div className="flex justify-end gap-2">
                        <Button onClick={onClose}>Cancel</Button>
                        <Button
                            htmlType="submit"
                            loading={isPending}
                            className="px-6 bg-primary text-white rounded hover:bg-primary_hover disabled:bg-gray-400 disabled:cursor-not-allowed"
                        >
                            Save Changes
                        </Button>
                    </div>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default EditProfileModal;